import { EMPTY_OBJECT } from "./utils";

export type FindUrlResult = {
	url: string;
	matchedText: string;
	start: number;
	end: number;
};

export type FindUrlOptions = {
	shouldMatchOnWww?: boolean;
	globalPositionOffset?: number;
};

export function findUrlsInText(
	input: string,
	options: FindUrlOptions = EMPTY_OBJECT
): readonly FindUrlResult[] {
	const {
		shouldMatchOnWww = false,
		globalPositionOffset = 0
	} = options;

	return [
		...findInternal(
			input,
			shouldMatchOnWww,
			globalPositionOffset
		)
	];
};

const urlRegex: RegExp = /(?:\s|^)((https?:\/\/|www\.)[-a-z0-9@:%._\+~#=]{1,256}\.[a-z0-9()]{1,6}\b(?:[-a-z0-9()@:%_\+.~#?&\/=]*))(?=$|\s)/i;

function* findInternal(
	input: string,
	shouldMatchOnWww: boolean,
	globalPositionOffset: number
): Iterable<FindUrlResult> {
	let searchContent: string = input;
	let offset: number = globalPositionOffset;

	while (true) {
		if (searchContent.length === 0) {
			return;
		}

		const searchResult: RegExpMatchArray | null = searchContent.match(urlRegex);

		if (!searchResult) {
			return;
		}

		const matchedText: string = searchResult[1];
		let url: string = matchedText;
		const urlIndicator: string = searchResult[2];
		const startInContent: number = searchContent.indexOf(matchedText);
		const endInContent: number = startInContent + matchedText.length;

		let isValidIndicator: boolean = true;

		if (urlIndicator.toLowerCase() === "www.") {
			if (!shouldMatchOnWww) {
				isValidIndicator = false;
			}

			const isIndicatorInUpperCase: boolean = urlIndicator === "WWW.";

			const schemaPrefix: string = isIndicatorInUpperCase
				? "HTTPS://"
				: "https://";

			url = schemaPrefix + matchedText;
		}

		if (isValidUrl(url) && isValidIndicator) {
			yield {
				url,
				matchedText,
				start: startInContent + offset,
				end: endInContent + offset
			};
		}

		offset += endInContent;
		searchContent = searchContent.substring(endInContent);
	}
}

export function isValidUrl(value: string): boolean {
	try {
		new URL(value);
		return true;
	} catch(e) {
		return false;
	}
}